import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { forwardRef, useImperativeHandle, useState } from "react";
import ReactModal from "react-modal";

ReactModal.setAppElement('#root');

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '50vw',
        height: '50vh',
        overflow: 'auto',
    },
};

export const Modal = forwardRef((props: {children: JSX.Element}, ref) => {
    
    const [modalIsOpen, setIsOpen] = useState<boolean>(false);
    const [modalWidth, setModalWidth] = useState<string>('50vw');
    const [modalHeight, setModalHeight] = useState<string>('50vh');
    const [modalHeader, setModalHeader] = useState<string>('');

    useImperativeHandle(ref, () => ({
        openModal (header: string = '', width: string = '50vw', height: string = '50vh') {
            setModalWidth(width);
            setModalHeight(height);
            setModalHeader(header);

            setIsOpen(true);
        },
        closeModal() {
            setIsOpen(false);
        },

    }));

    const openModal = () => {
        setIsOpen(true);
    }

    const closeModal = () => {
        setIsOpen(false);
    }


    return (
        <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal} style={{content: {...customStyles.content, width: modalWidth, height: modalHeight}}}>
            <div className="flex w-[100%] h-[100%] flex-col">
                <div className="flex w-[100%] h-[50px] justify-between items-center">
                    <span className="text-[25px] text-[black] font-bold">{modalHeader}</span>
                    <div className="flex items-center justify-center cursor-pointer text-[26px] text-[black]">
                        <FontAwesomeIcon icon={faXmark} onClick={closeModal} />
                    </div>
                </div>

                {props.children}
            </div>
        </ReactModal>
    );
})